"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
const firestore_2 = require("@react-query-firebase/firestore");
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
/** Lugares de los consultorios presenciales */
function usePlace(firestore, { corporate, id }, queryOptions) {
    const appointmentRef = (0, firestore_1.doc)(firestore, `corporate/${corporate != "" ? corporate : "false"}/places/${id}`);
    return (0, firestore_2.useFirestoreDocumentData)(keyFactory_1.FirestoreKeys.Especialista({
        name: "place",
        path: `corporate/${corporate != "" ? corporate : "false"}/places/${id}`
    }, [corporate, id]), appointmentRef, {}, queryOptions);
}
exports.default = usePlace;
